export const INVALID_EMAIL_SUBMITTED = 'INVALID_EMAIL_SUBMITTED';

export const invalidEmailSubmitted = () => dispatch =>
  dispatch({
    type: INVALID_EMAIL_SUBMITTED,
  });
